import React, { useEffect, useLayoutEffect, useState } from 'react';
import Field from '../fields/Field';
// import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import OrderItemsDetailHeader from './OrderItemsDetailHeader';
import {
    axiosViewOrderSettings, axiosPlaceBackOrder
} from '../../actions/orderActions';
import { handleAxiosErrors } from '../../_utils';
import OrderItem from './OrderItem';
import $ from 'jquery';
import { createAlert } from '../../dom/window';
import { getTranslation } from '../../lang/main';
import ReactLoading from 'react-loading';
import { getCartList } from '../../selectors/cartSelector';


function OrderItemsDetail(props) {
    const {
        isLoading,
    } = props;

    const notes = window.notes;
    const postmenLabelUrl = window.postmenLabelUrl;
    const [orderItems, setOrderItems] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [freightAmount, setFreightAmount] = useState(null);
    const [trackingNumber, setTrackingNumber] = useState(null);
    const [isQtyChanged, setIsQtyChanged] = useState(false);
    const [mutationInProcess, setMutationInProcess] = useState(false);
    const [initialCartItems, setInitialCartItems] = useState('');


    console.log("Cart Items =======> ", cartItems);
    useEffect(() => {
        if (!!initialCartItems && !!cartItems) {
            if (initialCartItems == JSON.stringify(cartItems)) {
                $('#order-calculation-section').show();
                $('#order-notes-section').show();
                setIsQtyChanged(false);
            } else {
                setIsQtyChanged(true);
                $('#order-calculation-section').hide();
                $('#order-notes-section').hide();
            }
        }
    }, [cartItems])

    const handleQuantityUpdate = (id, qtyPicked, newValue) => {

        const index = cartItems.findIndex(item => item.ID === id);
        if (index !== -1) {
            setCartItems(prevCartItems => [
                ...prevCartItems.slice(0, index),
                { ID: id, TotalUnitItems: qtyPicked },
                ...prevCartItems.slice(index + 1)
            ]);
        } else {
            setCartItems(prevCartItems => [
                ...prevCartItems,
                { ID: id, TotalUnitItems: qtyPicked }
            ]);
        }
    };

    const validateDecimal = (value) => {

        const regex = /^\d{0,6}(\.\d{0,2})?$/
        return regex.test(value)
    }

    const handleFreightAmountChange = (value) => {

        if (validateDecimal(value) || value === '') {
            setFreightAmount(value)
        }

    }

    const handleUpdateBackOrder = () => {

        if (freightAmount) {
            setMutationInProcess(true);
            axiosPlaceBackOrder(orderID, cartItems, freightAmount, trackingNumber ?? '')
                .then((response) => {
                    console.log(response.data.data.placeBackOrder);
                    window.location.reload();
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    setMutationInProcess(false);
                })
        } else {
            createAlert(
                {
                    message: getTranslation(
                        'Please Enter Freight Amount'
                    ),
                },
                'error'
            );
        }
    }

    const orderID = window.orderid || null;

    const request = async () => {
        await axiosViewOrderSettings(orderID)
            .then((response) => {

                let items = response.data.data.readOneCartOrder.Items.edges;
                let itemsDetail = items.map((item) => {

                    if (item?.node) {
                        return item.node;
                    }

                    return;
                });

                setOrderItems(getCartList(itemsDetail?.reduce((acc, obj) => {
                    obj.ParentItemID = obj?.ParentItem?.ID ?? 0;
                    acc[obj.ID] = obj
                    return acc;
                }, {})));

                let cartItems = itemsDetail.map((item) => {
                    if (item?.ParentItemID == 0) {
                        return { 'ID': item.ID, 'TotalUnitItems': item.TotalUnitItems }
                    }
                }).filter(Boolean);


                setCartItems(cartItems);

                setInitialCartItems(JSON.stringify(cartItems))
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
    };

    // Hooks
    useEffect(() => {
        request();
    }, []);

    return (
        <React.Fragment>
            <div
                className={`data-table ${isLoading === true &&
                    'data-table--loading'}`}
            >
                <div className='data-table__header'>
                    <div className='data-table__tr' role='row'>
                        <div className='data-table__th dt-cart-summary'>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'Image'} />
                            </span>
                        </div>
                        <div className='data-table__th dt-cart-summary'>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'SKU'} />
                            </span>
                        </div>
                        <div className='data-table__th dt-cart-summary'>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'ITEM'} />
                            </span>
                        </div>
                        <div className='data-table__th dt-cart-summary'>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'ORDER_QUANTITY_REQUIRED'} />
                            </span>
                        </div>
                        <div className='data-table__th dt-cart-summary' style={{ flex: '2 0 0' }}>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'ORDER_QUANTITY_PICKED'} />
                            </span>
                        </div>
                        <div className='data-table__th dt-cart-summary'>
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'ORDER_QUANTITY_BO'} />
                            </span>
                        </div>
                    </div>
                </div>
                {orderItems.length > 0 ? (
                    <div className='data-table__body'>
                        {orderItems.map((item, key) => {
                            const { Children = [] } = item;
                            return (
                                <React.Fragment>
                                    <OrderItem
                                        item={item}
                                        onQuantityUpdate={handleQuantityUpdate}
                                    />
                                    {/* {Children.map((subitem) => (
                                        <OrderItem
                                            key={subitem.ID}
                                            item={subitem}
                                            onQuantityUpdate={handleQuantityUpdate}
                                        />
                                    ))} */}
                                </React.Fragment>

                            );
                        })}
                    </div>
                ) : (
                    <div className='data-table__body-empty'>
                        <div className='text-box text-box--small text-box--center'>
                            <LocalizedMessage id={'ORDER_NO_ITEMS'} />
                        </div>
                    </div>
                )}
                {!!isQtyChanged && (
                    <div className="data-table__footer data-table__footer--small">
                        <div className="row row--vcenter-md">
                            <div className="col-xs-12 col-sm-4 col-md-4 col-sm-push-8 col-md-push-8 vspace--small vspace">
                                <div>
                                    <Field
                                        required={false}
                                        isLoading={isLoading}
                                        label='Freight Amount *'
                                        animatedLabel='Freight Amount *'
                                        name='FreightAmount'
                                        value={freightAmount || ''}
                                        onChange={e => {
                                            handleFreightAmountChange(e.target.value)
                                        }}
                                    />
                                </div>
                                <div>
                                    <Field
                                        required={false}
                                        isLoading={isLoading}
                                        label='Tracking Number'
                                        animatedLabel='Tracking Number'
                                        name='FreightAmount'
                                        value={trackingNumber || ''}
                                        onChange={e => {
                                            setTrackingNumber(e.target.value)
                                        }}
                                    />
                                </div>
                                <button
                                    disabled={mutationInProcess}
                                    className="button button--fullwidth"
                                    onClick={() => handleUpdateBackOrder()}
                                    style={{ position: 'relative' }}
                                >
                                    <span
                                        style={{
                                            opacity: mutationInProcess ? 0 : 1,
                                        }}
                                    >
                                        Update Order
                                    </span>
                                    {mutationInProcess &&
                                        <ReactLoading
                                            className='button__spinner'
                                            type='spin'
                                            color='white'
                                            height={20}
                                            width={20}
                                        />
                                    }
                                </button>
                            </div>
                            <div className="col-xs-12 col-sm-5 col-md-5 col-sm-pull-4 col-md-pull-4">
                                {(notes &&
                                    <div class="vspace">
                                        <span class="heading heading--lv5">
                                            <LocalizedMessage id={'FIELD.ADDITIONAL_DELIVERY_NOTES'} />
                                        </span>

                                        <div class="text-box text-box--small">
                                            <p dangerouslySetInnerHTML={{ __html: notes }}></p>
                                        </div>
                                    </div>
                                )}
                                <div className="row row--vcenter hidden-print">
                                    <div className="col-xs-12">
                                        <button className="button button--grey button--small button--thin hidden-xs hidden-sm" data-print><span className="icon icon-print"></span><span><LocalizedMessage id="PRINT" /> </span></button>
                                        {(postmenLabelUrl &&
                                            <a href="postmenLabelUrl" target="_blank" class="button button--grey button--small button--thin"><span class="icon icon-document"></span><span>Print Label</span></a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </React.Fragment >
    );
}

// default props
OrderItemsDetail.defaultProps = {
    // message: '',
};
// validate props
OrderItemsDetail.propTypes = {
    // message: PropTypes.string,
};

export default OrderItemsDetail;
